/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ store: NonNullable<unknown>, product: NonNullable<unknown> }} Flat_Bright_Raven_BeamInputs */

const en_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Success! Your purchase from ${i?.store} is now linked to your Brave account.`);
	return /** @type {LocalizedString} */ (`Success! Your subscription from ${i?.store} is now linked to your Brave account.`)
	
};

const id_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Berhasil! Pembelian Anda dari ${i?.store} kini terhubung dengan account Brave Anda.`);
	return /** @type {LocalizedString} */ (`Berhasil! Langganan Anda dari ${i?.store} kini terhubung dengan account Brave Anda.`)
	
};

const ms_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Berjaya! Pembelian anda dari ${i?.store} kini dipautkan ke akaun Brave anda.`);
	return /** @type {LocalizedString} */ (`Berjaya! Langganan anda dari ${i?.store} kini dipautkan ke akaun Brave anda.`)
	
};

const ca_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Èxit! La teva compra de ${i?.store} ja està vinculada al teu compte de Brave.`);
	return /** @type {LocalizedString} */ (`Èxit! La teva subscripció de ${i?.store} ja està vinculada al teu compte de Brave.`)
	
};

const cs_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Hotovo! Váš nákup z ${i?.store} je nyní propojen s vaším účtem Brave.`);
	return /** @type {LocalizedString} */ (`Hotovo! Vaše předplatné z ${i?.store} je nyní propojeno s vaším účtem Brave.`)
	
};

const da_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Succes! Dit køb fra ${i?.store} er nu knyttet til din Brave-konto.`);
	return /** @type {LocalizedString} */ (`Succes! Dit abonnement fra ${i?.store} er nu knyttet til din Brave-konto.`)
	
};

const de_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Geschafft! Ihr Kauf von ${i?.store} ist jetzt mit Ihrem Brave-Konto verknüpft.`);
	return /** @type {LocalizedString} */ (`Geschafft! Ihr Abonnement von ${i?.store} ist jetzt mit Ihrem Brave-Konto verknüpft.`)
	
};

const et_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Õnnestus! Sinu ost poest ${i?.store} on nüüd seotud sinu Brave'i kontoga.`);
	return /** @type {LocalizedString} */ (`Õnnestus! Sinu tellimus poest ${i?.store} on nüüd seotud sinu Brave'i kontoga.`)
	
};

const es_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`¡Listo! Tu compra en ${i?.store} ahora está vinculada a tu cuenta de Brave.`);
	return /** @type {LocalizedString} */ (`¡Listo! Tu suscripción en ${i?.store} ahora está vinculada a tu cuenta de Brave.`)
	
};

const fr_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Félicitations ! Votre achat effectué sur ${i?.store} est désormais lié à votre compte Brave.`);
	return /** @type {LocalizedString} */ (`Félicitations ! Votre abonnement souscrit sur ${i?.store} est désormais lié à votre compte Brave.`)
	
};

const hr_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Uspjeh! Vaša kupnja iz ${i?.store} sada je povezana s vašim Brave računom.`);
	return /** @type {LocalizedString} */ (`Uspjeh! Vaša pretplata iz ${i?.store} sada je povezana s vašim Brave računom.`)
	
};

const it_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Successo! Il tuo acquisto su ${i?.store} è ora collegato al tuo account Brave.`);
	return /** @type {LocalizedString} */ (`Successo! Il tuo abbonamento su ${i?.store} è ora collegato al tuo account Brave.`)
	
};

const lv_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Veiksmīgi! Jūsu pirkums no ${i?.store} tagad ir saistīts ar jūsu Brave kontu.`);
	return /** @type {LocalizedString} */ (`Veiksmīgi! Jūsu abonements no ${i?.store} tagad ir saistīts ar jūsu Brave kontu.`)
	
};

const lt_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Pavyko! Jūsų pirkinys iš ${i?.store} dabar susietas su jūsų Brave paskyra.`);
	return /** @type {LocalizedString} */ (`Pavyko! Jūsų prenumerata iš ${i?.store} dabar susieta su jūsų Brave paskyra.`)
	
};

const hu_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Sikerült! A ${i?.store} áruházból származó vásárlásod most már a Brave-fiókodhoz van társítva.`);
	return /** @type {LocalizedString} */ (`Sikerült! A ${i?.store} áruházból származó előfizetésed most már a Brave-fiókodhoz van társítva.`)
	
};

const nl_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Gelukt! Je aankoop bij ${i?.store} is nu gekoppeld aan je Brave-account.`);
	return /** @type {LocalizedString} */ (`Gelukt! Je abonnement bij ${i?.store} is nu gekoppeld aan je Brave-account.`)
	
};

const nb_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Suksess! Kjøpet ditt fra ${i?.store} er nå knyttet til din Brave-konto.`);
	return /** @type {LocalizedString} */ (`Suksess! Abonnementet ditt fra ${i?.store} er nå knyttet til din Brave-konto.`)
	
};

const pl_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Udało się! Twój zakup z ${i?.store} jest teraz powiązany z Twoim kontem Brave.`);
	return /** @type {LocalizedString} */ (`Udało się! Twoja subskrypcja z ${i?.store} jest teraz powiązana z Twoim kontem Brave.`)
	
};

const pt_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Sucesso! Sua compra feita na ${i?.store} agora está vinculada à sua conta Brave.`);
	return /** @type {LocalizedString} */ (`Sucesso! Sua assinatura da ${i?.store} agora está vinculada à sua conta Brave.`)
	
};

const ro_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Succes! Achiziția ta de la ${i?.store} este acum asociată cu contul tău Brave.`);
	return /** @type {LocalizedString} */ (`Succes! Abonamentul tău de la ${i?.store} este acum asociat cu contul tău Brave.`)
	
};

const sk_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Úspech! Váš nákup z ${i?.store} je teraz prepojený s vaším účtom Brave.`);
	return /** @type {LocalizedString} */ (`Úspech! Vaše predplatné z ${i?.store} je teraz prepojené s vaším účtom Brave.`)
	
};

const sl_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Uspeh! Vaš nakup iz ${i?.store} je zdaj povezan z vašim računom Brave.`);
	return /** @type {LocalizedString} */ (`Uspeh! Vaša naročnina iz ${i?.store} je zdaj povezana z vašim računom Brave.`)
	
};

const fi_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Onnistui! ${i?.store}-ostoksesi on nyt linkitetty Brave-tiliisi.`);
	return /** @type {LocalizedString} */ (`Onnistui! ${i?.store}-tilauksesi on nyt linkitetty Brave-tiliisi.`)
	
};

const sv_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Klart! Ditt köp från ${i?.store} är nu kopplat till ditt Brave-konto.`);
	return /** @type {LocalizedString} */ (`Klart! Din prenumeration från ${i?.store} är nu kopplad till ditt Brave-konto.`)
	
};

const vi_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Thành công! Mua hàng của bạn từ ${i?.store} hiện đã được liên kết với tài khoản Brave của bạn.`);
	return /** @type {LocalizedString} */ (`Thành công! Đăng ký của bạn từ ${i?.store} hiện đã được liên kết với tài khoản Brave của bạn.`)
	
};

const tr_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Başarılı! ${i?.store} üzerinden yaptığınız satın alma artık Brave hesabınıza bağlı.`);
	return /** @type {LocalizedString} */ (`Başarılı! ${i?.store} üzerinden yaptığınız abonelik artık Brave hesabınıza bağlı.`)
	
};

const el_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Επιτυχία! Η αγορά σας από το ${i?.store} είναι πλέον συνδεδεμένη με τον λογαριασμό σας Brave.`);
	return /** @type {LocalizedString} */ (`Επιτυχία! Η συνδρομή σας από το ${i?.store} είναι πλέον συνδεδεμένη με τον λογαριασμό σας Brave.`)
	
};

const bg_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Успех! Покупката ви от ${i?.store} вече е свързана с вашия Brave акаунт.`);
	return /** @type {LocalizedString} */ (`Успех! Абонаментът ви от ${i?.store} вече е свързан с вашия Brave акаунт.`)
	
};

const ru_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Готово! Ваша покупка в ${i?.store} теперь привязана к вашему аккаунту Brave.`);
	return /** @type {LocalizedString} */ (`Готово! Ваша подписка из ${i?.store} теперь привязана к вашему аккаунту Brave.`)
	
};

const sr_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Успех! Ваша куповина из ${i?.store} је сада повезана са вашим Brave account-ом.`);
	return /** @type {LocalizedString} */ (`Успех! Ваша претплата из ${i?.store} је сада повезана са вашим Brave account-ом.`)
	
};

const uk_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`Успіх! Вашу покупку з ${i?.store} тепер пов'язано з вашим обліковим записом Brave.`);
	return /** @type {LocalizedString} */ (`Успіх! Вашу підписку з ${i?.store} тепер пов'язано з вашим обліковим записом Brave.`)
	
};

const ka_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`წარმატება! თქვენი შეძენა ${i?.store}-დან ახლა დაკავშირებულია თქვენს Brave ანგარიშთან.`);
	return /** @type {LocalizedString} */ (`წარმატება! თქვენი გამოწერა ${i?.store}-დან ახლა დაკავშირებულია თქვენს Brave ანგარიშთან.`)
	
};

const hi_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`सफलता! ${i?.store} से आपकी खरीद अब आपके Brave account से जुड़ी हुई है।`);
	return /** @type {LocalizedString} */ (`सफलता! ${i?.store} से आपकी सदस्यता अब आपके Brave account से जुड़ी हुई है।`)
	
};

const th_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`สำเร็จ! การซื้อของคุณจาก ${i?.store} เชื่อมโยงกับบัญชี Brave ของคุณแล้ว`);
	return /** @type {LocalizedString} */ (`สำเร็จ! การสมัครสมาชิกของคุณจาก ${i?.store} เชื่อมโยงกับบัญชี Brave ของคุณแล้ว`)
	
};

const ko_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`성공! ${i?.store}에서의 구매가 이제 Brave 계정에 연결되었습니다.`);
	return /** @type {LocalizedString} */ (`성공! ${i?.store}에서의 구독이 이제 Brave 계정에 연결되었습니다.`)
	
};

const zh_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`成功！您的订阅现已链接。`)
};

const zh_tw_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`成功！您從 ${i?.store} 的購買現已連結至您的 Brave 帳戶。`);
	return /** @type {LocalizedString} */ (`成功！您從 ${i?.store} 的訂閱現已連結至您的 Brave 帳戶。`)
	
};

const ja_flat_bright_raven_beam = /** @type {(inputs: Flat_Bright_Raven_BeamInputs) => LocalizedString} */ (i) => {
	if (i?.product === "origin") return /** @type {LocalizedString} */ (`成功しました！${i?.store} からの購入が Brave アカウントにリンクされました。`);
	return /** @type {LocalizedString} */ (`成功しました！${i?.store} からのサブスクリプションが Brave アカウントにリンクされました。`)
	
};

/**
* | product | output |
* | --- | --- |
* | "origin" | "Success! Your purchase from {store} is now linked to your Brave account." |
* | * | "Success! Your subscription from {store} is now linked to your Brave account." |
*
* @param {Flat_Bright_Raven_BeamInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const flat_bright_raven_beam = /** @type {((inputs: Flat_Bright_Raven_BeamInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flat_Bright_Raven_BeamInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_flat_bright_raven_beam(inputs)
	if (locale === "ms") return ms_flat_bright_raven_beam(inputs)
	if (locale === "ca") return ca_flat_bright_raven_beam(inputs)
	if (locale === "cs") return cs_flat_bright_raven_beam(inputs)
	if (locale === "da") return da_flat_bright_raven_beam(inputs)
	if (locale === "de") return de_flat_bright_raven_beam(inputs)
	if (locale === "et") return et_flat_bright_raven_beam(inputs)
	if (locale === "es") return es_flat_bright_raven_beam(inputs)
	if (locale === "fr") return fr_flat_bright_raven_beam(inputs)
	if (locale === "hr") return hr_flat_bright_raven_beam(inputs)
	if (locale === "it") return it_flat_bright_raven_beam(inputs)
	if (locale === "lv") return lv_flat_bright_raven_beam(inputs)
	if (locale === "lt") return lt_flat_bright_raven_beam(inputs)
	if (locale === "hu") return hu_flat_bright_raven_beam(inputs)
	if (locale === "nl") return nl_flat_bright_raven_beam(inputs)
	if (locale === "nb") return nb_flat_bright_raven_beam(inputs)
	if (locale === "pl") return pl_flat_bright_raven_beam(inputs)
	if (locale === "pt") return pt_flat_bright_raven_beam(inputs)
	if (locale === "ro") return ro_flat_bright_raven_beam(inputs)
	if (locale === "sk") return sk_flat_bright_raven_beam(inputs)
	if (locale === "sl") return sl_flat_bright_raven_beam(inputs)
	if (locale === "fi") return fi_flat_bright_raven_beam(inputs)
	if (locale === "sv") return sv_flat_bright_raven_beam(inputs)
	if (locale === "vi") return vi_flat_bright_raven_beam(inputs)
	if (locale === "tr") return tr_flat_bright_raven_beam(inputs)
	if (locale === "el") return el_flat_bright_raven_beam(inputs)
	if (locale === "bg") return bg_flat_bright_raven_beam(inputs)
	if (locale === "ru") return ru_flat_bright_raven_beam(inputs)
	if (locale === "sr") return sr_flat_bright_raven_beam(inputs)
	if (locale === "uk") return uk_flat_bright_raven_beam(inputs)
	if (locale === "ka") return ka_flat_bright_raven_beam(inputs)
	if (locale === "hi") return hi_flat_bright_raven_beam(inputs)
	if (locale === "th") return th_flat_bright_raven_beam(inputs)
	if (locale === "ko") return ko_flat_bright_raven_beam(inputs)
	if (locale === "zh") return zh_flat_bright_raven_beam(inputs)
	if (locale === "zh-tw") return zh_tw_flat_bright_raven_beam(inputs)
	if (locale === "ja") return ja_flat_bright_raven_beam(inputs)
	return en_flat_bright_raven_beam(inputs)
});